export default "__VITE_ASSET__B8j910U0__"